class EmailSignup extends HTMLElement {

  connectedCallback() {
    this.form = this.querySelector('.email-signup__form');
    this.emailInput = this.querySelector('input[type="email"]');
    this.marketingCheckbox = this.querySelector('input[name="accepts_marketing"]');
    this.submitButton = this.querySelector('.email-signup__button');

    // Klaviyo configuration - these should be set as data attributes on the element
    this.klaviyoCompanyId = this.getAttribute('data-klaviyo-company-id');
    this.klaviyoListId = this.getAttribute('data-klaviyo-list-id');
    this.klaviyoEnabled = this.hasAttribute('data-klaviyo-enabled');

    if (this.form && this.klaviyoEnabled && this.klaviyoCompanyId && this.klaviyoListId) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    } else {
      console.warn('Klaviyo integration is not properly configured for EmailSignup component.');
    }

    // Set up button state management
    this.updateButtonState();
    this.emailInput?.addEventListener('input', this.updateButtonState.bind(this));
    this.marketingCheckbox?.addEventListener('change', this.updateButtonState.bind(this));
  }

  updateButtonState() {
    if (!this.submitButton) return;

    const hasEmail = this.emailInput?.value?.trim().length > 0;
    const hasConsent = !this.marketingCheckbox || this.marketingCheckbox.checked;

    this.submitButton.disabled = !hasEmail || !hasConsent;
  }

  async handleSubmit(e) {
    // Only subscribe to Klaviyo if marketing checkbox is checked (or doesn't exist, meaning consent is implied)
    const hasConsent = !this.marketingCheckbox || this.marketingCheckbox.checked;
    
    if (!hasConsent || !this.emailInput?.value) return;

    const email = this.emailInput.value;

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.klaviyoCompanyId}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          'Revision': '2025-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website Email Signup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: this.klaviyoListId
                }
              }
            }
          }
        })
      });
      if (response.ok) {
        console.log('Klaviyo subscription successful');
      } else {
        console.error('Klaviyo subscription failed:', response.statusText);
      }
    } catch (error) {
      console.error('Klaviyo subscription error:', error);
    }
  }
}

if (!customElements.get('email-signup')) {
  customElements.define('email-signup', EmailSignup);
}